import { Component, OnInit, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ResellerService } from '@services/reseller.service';
import { AtlasGridHtmlRendererComponent } from '@ui/components/atlas-grid/renderer/html-renderer.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { creditsTypeIcon } from '@utils/constants';
import { SmsService } from '@services/sms.service';
import { Router } from '@angular/router';
import { ContactGroups } from '@models/contact/group';
import { ResellerProfile } from '@models/reseller/profile';
import { User } from '@models/user';
import { AtlasToastService } from '@services/atlas-toast.service';
import { UserService } from '@services/user.service';
import { AtlasGridOptions } from '@ui/components/atlas-grid/altas-grid-options.model';
import { AtlasGridComponent } from '@ui/components/atlas-grid/atlas-grid.component';
import { ButtonGroupRendererComponent } from '@ui/components/atlas-grid/renderer/buttongroup-renderer.component';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '@services/loader.service';

// import {faEdit, faEye, faTrash} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'wsb-reseller-profiles',
  templateUrl: './reseller-profiles.component.html',
  styleUrls: ['./reseller-profiles.component.scss'],
  animations: [
    trigger('gridIsLoaded', [
      state('hide', style({ opacity: 0 })),
      state('show', style({ opacity: 1 })),
      transition('hide => show', animate('150ms', style({ opacity: 1 }))),
      transition('show => hide', animate('150ms', style({ opacity: 0 })))
    ])
  ],
  standalone: false
})
export class ResellerProfilesComponent implements OnInit {
  @ViewChild('pageDashboard', { static: true }) $pageDashboard;
  @ViewChild('modalEdit') modalEdit;
  @ViewChild('modalDelete') modalDelete;
  @ViewChild(AtlasGridComponent) grid: AtlasGridComponent;
  modalEditModal: NgbModalRef;
  modalDeleteModal: NgbModalRef;
  editForm: UntypedFormGroup = null;
  sharingGroupForm: UntypedFormGroup = null;
  user: User | null;
  resellerProfileToEdit: ResellerProfile | null;
  resellerProfileToDelete: ResellerProfile | null;
  tableColumnDefs = null;
  tableGridOptions = null;
  tableData = null;
  components = {
    buttonGroupRenderer: ButtonGroupRendererComponent,
    htmlRenderer: AtlasGridHtmlRendererComponent
  };
  tableLoading: boolean;

  credits: any[] = [];

  services = [];
  sharingGroup = false;
  contactGroups: ContactGroups;
  optionsSelectSharingGroup = {
    multiple: true
  };
  sharedElementsLabel = ['reseller_profiles_table_templates', 'reseller_profiles_table_groups', 'reseller_profiles_table_blacklist'];
  value = [];
  sharingGroupBuffer = [];
  sharingGrouppPage = 0;
  numberOfItemsFromEndBeforeFetchingMore = 5;
  loading = false;
  gridAnimationState = 'hide';

  constructor(
    private userService: UserService,
    private resellerService: ResellerService,
    private modalService: NgbModal,
    private formBuilder: UntypedFormBuilder,
    private atlasToast: AtlasToastService,
    private translateService: TranslateService,
    private smsService: SmsService,
    private loaderService: LoaderService,
    private router: Router
  ) {}

  ngOnInit() {
    // console.log('key', this.sessionStorage.retrieve('wsb-user-key'));
    this.editForm = this.formBuilder.group({
      name: ['', [Validators.required]]
    });
    this.sharingGroupForm = this.formBuilder.group({
      idUserOwner: ['', [Validators.required]],
      groupIds: [this.formBuilder.array([]), [Validators.required]],
      idSubaccountProfile: ['', [Validators.required]]
    });
    const tableColumnDefs = [
      {
        headerNameTranslate: 'reseller_profiles_table_id',
        field: 'idSubaccountProfile'
      },
      {
        headerNameTranslate: 'contact_name',
        field: 'name',
        minWidth: 200,
        wrapText: true
      },
      {
        headerNameTranslate: 'reseller_profiles_table_sharing_elements',
        field: 'shared',
        cellRenderer: profile => {
          let labels;
          this.translateService.get(this.sharedElementsLabel).subscribe(label => {
            labels = label;
          });
          return (
            labels[this.sharedElementsLabel[0]] +
            ': ' +
            profile.data.sharedTemplates.length +
            '<br>' +
            labels[this.sharedElementsLabel[1]] +
            ': ' +
            profile.data.sharedGroups.length +
            '<br>' +
            labels[this.sharedElementsLabel[2]] +
            ': ' +
            (profile.data.sharedBlacklists.length > 0 ? 'yes' : 'No')
          );
        },
        cellStyle: { 'line-height': '20px' }
      },
      {
        headerNameTranslate: 'reseller_profiles_table_services',
        field: 'enabledServices',
        cellRenderer: 'htmlRenderer',
        wrapText: true,
        suppressSizeToFit: true,
        cellRendererParams: {
          contentObservable: params =>
            new Observable(observer => {
              if (!params || !params.data) {
                observer.next(null);
                observer.complete();
              }
              this.translateService.get(params.data.enabledServices.map(x => 'reseller_profiles_table_' + x)).subscribe(y => {
                observer.next(
                  params.data.enabledServices
                    .map(x => y['reseller_profiles_table_' + x])
                    .sort()
                    .join(', ')
                );
                observer.complete();
              });
            })
        },
        cellStyle: { 'line-height': '20px', 'overflow-y': 'auto' }
      },
      {
        headerNameTranslate: 'reseller_profiles_table_types',
        field: 'enabledSMSQualities',
        cellRenderer: 'htmlRenderer',
        wrapText: true,
        suppressSizeToFit: true,
        cellStyle: { 'line-height': '20px', 'overflow-y': 'auto' },
        cellRendererParams: {
          content: params =>
            params && params.data
              ? params.data.enabledSMSQualities
                  .map(x => {
                    return this.credits.find(y => y.value === x)?.title;
                  })
                  .sort()
                  .join(',')
              : ''
          // contentObservable: params =>
          //   new Observable(observer => {
          //     if (!params || !params.data) {
          //       observer.next(null);
          //       observer.complete();
          //     }
          //     this.translateService.get(params.data.enabledSMSQualities.map(x => 'credit_type_' + x))
          //       .subscribe(y => {
          //         observer.next(params.data.enabledSMSQualities.map(x => y['credit_type_' + x]).join(', '));
          //         observer.complete();
          //       });
          //   })
        }
      },
      {
        headerNameTranslate: 'reseller_profiles_table_subaccounts',
        field: 'numSubaccount'
      },
      {
        headerNameTranslate: 'common_actions',
        suppressCellFocus: true,
        cellRenderer: 'buttonGroupRenderer',
        cellRendererParams: {
          items: [
            {
              onClick: e => this.editProfil(e),
              label: 'common_edit'
              // variant: 'primary',
            },
            {
              onClick: e => this.openModalDelete(e),
              label: 'common_delete',
              hide: data => {
                if (!data) {
                  return true;
                } else {
                  return data.isDefault;
                }
              }
              // variant: 'danger',
            }
          ]
        },
        cellClass: ['button-group', 'text-end'],
        maxWidth: 82
      }
    ];

    this.smsService.getMessageTypes().subscribe(data => {
      this.credits = data.data.map(x => {
        return {
          value: x.id,
          icon: creditsTypeIcon[x.id],
          title: x.label,
          enabled: false
        };
      });

      // Do not show sms qualities if only one
      this.tableColumnDefs = tableColumnDefs.filter(
        obj => this.credits.length > 1 || obj.headerNameTranslate !== 'reseller_profiles_table_types'
      );
    });
    this.resellerService.getActivableServices().subscribe(data => {
      this.services = data.map(x => {
        return {
          name: x,
          enabled: false
        };
      });
    });

    this.userService.getAuthenticationState().subscribe(next => (this.user = next));

    this.tableGridOptions = AtlasGridOptions.deserialize({
      disablePagination: true,
      rowHeight: 70
    });
    this.reloadList();
  }

  reloadList() {
    this.loaderService.show();
    this.tableLoading = true;
    this.resellerService
      .getProfiles()
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe(data => {
        this.tableData = data.data;
        this.tableLoading = false;
        this.gridAnimationState = 'show';
      });
  }

  createNewProfil() {
    this.router.navigate(['/reseller/profile/create']);
  }

  editProfil(data) {
    this.router.navigate(['/reseller/profile', data.idSubaccountProfile]);
  }

  smsEnabled(): boolean {
    const el = this.services.find(x => x.name === 'sms');
    return el && el.enabled;
  }

  openModalDelete(data: any): void {
    this.resellerProfileToDelete = data;
    this.modalDeleteModal = this.modalService.open(this.modalDelete);
    this.modalDeleteModal.result.then(
      result => {},
      reason => {}
    );
  }

  successOperation() {
    this.editForm.reset();
    this.atlasToast.success('common_success', null);
    this.editForm.reset();
    this.editForm.enable();
    this.reloadList();
  }

  errorOperation() {
    this.atlasToast.error('common_error', null);
    this.editForm.enable();
    this.reloadList();
  }

  modalDeleteForm(): void {
    const that = this;
    this.resellerService.removeProfile(this.resellerProfileToDelete).subscribe(
      () => {
        this.atlasToast.success('common_success', null);
        that.reloadList();
      },
      () => {
        this.atlasToast.error('common_error', null);
        that.reloadList();
      },
      () => {}
    );
    this.modalDeleteModal.close();
  }
}
